import { render, staticRenderFns } from "./CompraAprovarAdmin.vue?vue&type=template&id=9af42674"
import script from "./CompraAprovarAdmin.vue?vue&type=script&lang=js"
export * from "./CompraAprovarAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports